// extracted by mini-css-extract-plugin
module.exports = {"chart":"falls-bar_chart_1ACLG","content":"falls-bar_content_2-Rzt"};